import { Controller } from "stimulus"
import tippy from 'tippy.js';

class TickerTableController extends Controller {
  static targets = [
    'tickerTableContainer',
    'tickerTableCellAnchor',
    'tickerTableCellSponsorRow'
  ]

  connect() {
    this.__renderTooltips();
  }

  onScroll(event) {
    let container_x_pos = this.__getContainerXPosition();
    for(var idx = 0; idx < this.tickerTableCellSponsorRowTargets.length; idx++) {
      let item = this.tickerTableCellSponsorRowTargets[idx];
      item.setAttribute('style', `transform: translateX(${this.__invertDirection(container_x_pos)}px);`);
    }
  }

  __checkContainerPosition() {
    return this.tickerTableContainerTarget.getBoundingClientRect();
  }

  __getContainerXPosition() {
    return this.__checkContainerPosition().x;
  }

  __invertDirection(el) {
    if(el < 0) {
      return Math.abs(el);
    } else {
      return -Math.abs(el)
    }
  }

  __renderTooltips() {
    tippy(document.querySelectorAll('.dynamic-tooltip'), {
      content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      allowHTML: true,
      interactive: true,
      maxWidth: 240,
      theme: 'light',
      placement: 'bottom'
    })
  }
}

export default TickerTableController;
